import {EntityType} from "../@types/entity";
import type {EntitySchema} from "../@types/schema";
import ArrayMap from "../lib/ArrayMap";
import AccountingConnection from './accountingConnection';
import ActivityCategory from './activityCategory';
import ActivityType from './activityType';
import Address from './address';
import Answer from './answer';
import BankAccount from './bankAccount';
import Blackout from './blackout';
import Calendar from './calendar';
import CalendarShare from './calendarShare';
import Category from './category';
import Campaign from './campaign';
import Docket from './docket';
import Matter from './matter';
import Comment from './comment';
import CaseType from './caseType';
import CaseTypeStage from './caseTypeStage';
import Deadline from './deadline';
import DeadlineRule from './deadlineRule';
import Conflict from './conflict';
import Contact from './contact';
import Court from './court';
import CourtDeadlineRule from './courtDeadlineRule';
import Discount from './discount';
import EntityTimestamp from './entityTimestamp';
import EthicalWall from './ethicalWall';
import Document from './document';
import Expense from './expense';
import Event from './event';
import Firm from './firm';
import FlatFee from './flatFee';
import FlatFeeMilestone from './flatFeeMilestone';
import Group from './group';
import HolidayCalendar from './holidayCalendar';
import Identification from './identification';
import ImportExport from './importExport';
import ImportSource from './importSource';
import Invoice from './invoice';
import InvoiceBatch from './invoiceBatch';
import InvoiceBatchItem from './invoiceBatchItem';
import Lawpay from './lawpay';
import Lead from './lead';
import Lookup from './lookup';
import MatterStage from './matterStage';
import Milestone from './milestone';
import Option from './option';
import Participant from './participant';
import Privilege from './privilege';
import Question from './question';
import RedFlagType from './redFlagType';
import RedFlag from './redFlag';
import Resource from './resource';
import Referral from './referral';
import Role from './role';
import Task from './task';
import TaskSeries from './taskSeries';
import TemplateTask from './templateTask';
import TimeOff from './timeOff';
import Transaction from './transaction';
import User from './user';
export type EntityNames = 'accountingConnection' | 'activityCategory' | 'activityType' | 'address' | 'answer' | 'bankAccount' | 'blackout' | 'calendar' | 'calendarShare' | 'category' | 'campaign' | 'docket' | 'matter' | 'comment' | 'caseType' | 'caseTypeStage' | 'deadline' | 'deadlineRule' | 'conflict' | 'contact' | 'court' | 'courtDeadlineRule' | 'discount' | 'entityTimestamp' | 'ethicalWall' | 'document' | 'expense' | 'event' | 'firm' | 'flatFee' | 'flatFeeMilestone' | 'group' | 'holidayCalendar' | 'identification' | 'importExport' | 'importSource' | 'invoice' | 'invoiceBatch' | 'invoiceBatchItem' | 'lawpay' | 'lead' | 'lookup' | 'matterStage' | 'milestone' | 'option' | 'participant' | 'privilege' | 'question' | 'redFlagType' | 'redFlag' | 'resource' | 'referral' | 'role' | 'task' | 'taskSeries' | 'templateTask' | 'timeOff' | 'transaction' | 'user';
export type EntityPlurals = 'accountingConnections' | 'activityCategories' | 'activityTypes' | 'addresses' | 'answers' | 'bankAccounts' | 'blackouts' | 'calendars' | 'calendarShares' | 'categories' | 'campaigns' | 'dockets' | 'matters' | 'comments' | 'caseTypes' | 'caseTypeStages' | 'deadlines' | 'deadlineRules' | 'conflicts' | 'contacts' | 'courts' | 'courtDeadlineRules' | 'discounts' | 'entityTimestamps' | 'ethicalWalls' | 'documents' | 'expenses' | 'events' | 'firms' | 'flatFees' | 'flatFeeMilestones' | 'groups' | 'holidayCalendars' | 'identifications' | 'importExports' | 'importSources' | 'invoices' | 'invoiceBatches' | 'invoiceBatchItems' | 'lawpays' | 'leads' | 'lookups' | 'matterStages' | 'milestones' | 'options' | 'participants' | 'privileges' | 'questions' | 'redFlagTypes' | 'redFlags' | 'resources' | 'referrals' | 'roles' | 'tasks' | 'taskSerieses' | 'templateTasks' | 'timeOffs' | 'transactions' | 'users';
export type EntityTypes = AccountingConnection | ActivityCategory | ActivityType | Address | Answer | BankAccount | Blackout | Calendar | CalendarShare | Category | Campaign | Docket | Matter | Comment | CaseType | CaseTypeStage | Deadline | DeadlineRule | Conflict | Contact | Court | CourtDeadlineRule | Discount | EntityTimestamp | EthicalWall | Document | Expense | Event | Firm | FlatFee | FlatFeeMilestone | Group | HolidayCalendar | Identification | ImportExport | ImportSource | Invoice | InvoiceBatch | InvoiceBatchItem | Lawpay | Lead | Lookup | MatterStage | Milestone | Option | Participant | Privilege | Question | RedFlagType | RedFlag | Resource | Referral | Role | Task | TaskSeries | TemplateTask | TimeOff | Transaction | User;
export type EntityTypeTypes = typeof AccountingConnection | typeof ActivityCategory | typeof ActivityType | typeof Address | typeof Answer | typeof BankAccount | typeof Blackout | typeof Calendar | typeof CalendarShare | typeof Category | typeof Campaign | typeof Docket | typeof Matter | typeof Comment | typeof CaseType | typeof CaseTypeStage | typeof Deadline | typeof DeadlineRule | typeof Conflict | typeof Contact | typeof Court | typeof CourtDeadlineRule | typeof Discount | typeof EntityTimestamp | typeof EthicalWall | typeof Document | typeof Expense | typeof Event | typeof Firm | typeof FlatFee | typeof FlatFeeMilestone | typeof Group | typeof HolidayCalendar | typeof Identification | typeof ImportExport | typeof ImportSource | typeof Invoice | typeof InvoiceBatch | typeof InvoiceBatchItem | typeof Lawpay | typeof Lead | typeof Lookup | typeof MatterStage | typeof Milestone | typeof Option | typeof Participant | typeof Privilege | typeof Question | typeof RedFlagType | typeof RedFlag | typeof Resource | typeof Referral | typeof Role | typeof Task | typeof TaskSeries | typeof TemplateTask | typeof TimeOff | typeof Transaction | typeof User;
export type AccountingConnectionsLike = AccountingConnection[] | ArrayMap<AccountingConnection>;
export type ActivityCategoriesLike = ActivityCategory[] | ArrayMap<ActivityCategory>;
export type ActivityTypesLike = ActivityType[] | ArrayMap<ActivityType>;
export type AddressesLike = Address[] | ArrayMap<Address>;
export type AnswersLike = Answer[] | ArrayMap<Answer>;
export type BankAccountsLike = BankAccount[] | ArrayMap<BankAccount>;
export type BlackoutsLike = Blackout[] | ArrayMap<Blackout>;
export type CalendarsLike = Calendar[] | ArrayMap<Calendar>;
export type CalendarSharesLike = CalendarShare[] | ArrayMap<CalendarShare>;
export type CategoriesLike = Category[] | ArrayMap<Category>;
export type CampaignsLike = Campaign[] | ArrayMap<Campaign>;
export type DocketsLike = Docket[] | ArrayMap<Docket>;
export type MattersLike = Matter[] | ArrayMap<Matter>;
export type CommentsLike = Comment[] | ArrayMap<Comment>;
export type CaseTypesLike = CaseType[] | ArrayMap<CaseType>;
export type CaseTypeStagesLike = CaseTypeStage[] | ArrayMap<CaseTypeStage>;
export type DeadlinesLike = Deadline[] | ArrayMap<Deadline>;
export type DeadlineRulesLike = DeadlineRule[] | ArrayMap<DeadlineRule>;
export type ConflictsLike = Conflict[] | ArrayMap<Conflict>;
export type ContactsLike = Contact[] | ArrayMap<Contact>;
export type CourtsLike = Court[] | ArrayMap<Court>;
export type CourtDeadlineRulesLike = CourtDeadlineRule[] | ArrayMap<CourtDeadlineRule>;
export type DiscountsLike = Discount[] | ArrayMap<Discount>;
export type EntityTimestampsLike = EntityTimestamp[] | ArrayMap<EntityTimestamp>;
export type EthicalWallsLike = EthicalWall[] | ArrayMap<EthicalWall>;
export type DocumentsLike = Document[] | ArrayMap<Document>;
export type ExpensesLike = Expense[] | ArrayMap<Expense>;
export type EventsLike = Event[] | ArrayMap<Event>;
export type FirmsLike = Firm[] | ArrayMap<Firm>;
export type FlatFeesLike = FlatFee[] | ArrayMap<FlatFee>;
export type FlatFeeMilestonesLike = FlatFeeMilestone[] | ArrayMap<FlatFeeMilestone>;
export type GroupsLike = Group[] | ArrayMap<Group>;
export type HolidayCalendarsLike = HolidayCalendar[] | ArrayMap<HolidayCalendar>;
export type IdentificationsLike = Identification[] | ArrayMap<Identification>;
export type ImportExportsLike = ImportExport[] | ArrayMap<ImportExport>;
export type ImportSourcesLike = ImportSource[] | ArrayMap<ImportSource>;
export type InvoicesLike = Invoice[] | ArrayMap<Invoice>;
export type InvoiceBatchesLike = InvoiceBatch[] | ArrayMap<InvoiceBatch>;
export type InvoiceBatchItemsLike = InvoiceBatchItem[] | ArrayMap<InvoiceBatchItem>;
export type LawpaysLike = Lawpay[] | ArrayMap<Lawpay>;
export type LeadsLike = Lead[] | ArrayMap<Lead>;
export type LookupsLike = Lookup[] | ArrayMap<Lookup>;
export type MatterStagesLike = MatterStage[] | ArrayMap<MatterStage>;
export type MilestonesLike = Milestone[] | ArrayMap<Milestone>;
export type OptionsLike = Option[] | ArrayMap<Option>;
export type ParticipantsLike = Participant[] | ArrayMap<Participant>;
export type PrivilegesLike = Privilege[] | ArrayMap<Privilege>;
export type QuestionsLike = Question[] | ArrayMap<Question>;
export type RedFlagTypesLike = RedFlagType[] | ArrayMap<RedFlagType>;
export type RedFlagsLike = RedFlag[] | ArrayMap<RedFlag>;
export type ResourcesLike = Resource[] | ArrayMap<Resource>;
export type ReferralsLike = Referral[] | ArrayMap<Referral>;
export type RolesLike = Role[] | ArrayMap<Role>;
export type TasksLike = Task[] | ArrayMap<Task>;
export type TaskSeriesesLike = TaskSeries[] | ArrayMap<TaskSeries>;
export type TemplateTasksLike = TemplateTask[] | ArrayMap<TemplateTask>;
export type TimeOffsLike = TimeOff[] | ArrayMap<TimeOff>;
export type TransactionsLike = Transaction[] | ArrayMap<Transaction>;
export type UsersLike = User[] | ArrayMap<User>;
function cast(entity: string, value: object): EntityType {
    switch(entity) {
        case 'accountingConnections': return new AccountingConnection(value);
        case 'accountingConnection': return new AccountingConnection(value);
        case 'activityCategories': return new ActivityCategory(value);
        case 'activityCategory': return new ActivityCategory(value);
        case 'activityTypes': return new ActivityType(value);
        case 'activityType': return new ActivityType(value);
        case 'addresses': return new Address(value);
        case 'address': return new Address(value);
        case 'answers': return new Answer(value);
        case 'answer': return new Answer(value);
        case 'bankAccounts': return new BankAccount(value);
        case 'bankAccount': return new BankAccount(value);
        case 'blackouts': return new Blackout(value);
        case 'blackout': return new Blackout(value);
        case 'calendars': return new Calendar(value);
        case 'calendar': return new Calendar(value);
        case 'calendarShares': return new CalendarShare(value);
        case 'calendarShare': return new CalendarShare(value);
        case 'categories': return new Category(value);
        case 'category': return new Category(value);
        case 'campaigns': return new Campaign(value);
        case 'campaign': return new Campaign(value);
        case 'dockets': return new Docket(value);
        case 'docket': return new Docket(value);
        case 'matters': return new Matter(value);
        case 'matter': return new Matter(value);
        case 'comments': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new Comment(value);
        case 'comment': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new Comment(value);
        case 'caseTypes': return new CaseType(value);
        case 'caseType': return new CaseType(value);
        case 'caseTypeStages': return new CaseTypeStage(value);
        case 'caseTypeStage': return new CaseTypeStage(value);
        case 'deadlines': return new Deadline(value);
        case 'deadline': return new Deadline(value);
        case 'deadlineRules': return new DeadlineRule(value);
        case 'deadlineRule': return new DeadlineRule(value);
        case 'conflicts': return new Conflict(value);
        case 'conflict': return new Conflict(value);
        case 'contacts': return new Contact(value);
        case 'contact': return new Contact(value);
        case 'courts': return new Court(value);
        case 'court': return new Court(value);
        case 'courtDeadlineRules': return new CourtDeadlineRule(value);
        case 'courtDeadlineRule': return new CourtDeadlineRule(value);
        case 'discounts': return new Discount(value);
        case 'discount': return new Discount(value);
        case 'entityTimestamps': return new EntityTimestamp(value);
        case 'entityTimestamp': return new EntityTimestamp(value);
        case 'ethicalWalls': return new EthicalWall(value);
        case 'ethicalWall': return new EthicalWall(value);
        case 'documents': return new Document(value);
        case 'document': return new Document(value);
        case 'expenses': return new Expense(value);
        case 'expense': return new Expense(value);
        case 'events': return new Event(value);
        case 'event': return new Event(value);
        case 'firms': return new Firm(value);
        case 'firm': return new Firm(value);
        case 'flatFees': return new FlatFee(value);
        case 'flatFee': return new FlatFee(value);
        case 'flatFeeMilestones': return new FlatFeeMilestone(value);
        case 'flatFeeMilestone': return new FlatFeeMilestone(value);
        case 'groups': return new Group(value);
        case 'group': return new Group(value);
        case 'holidayCalendars': return new HolidayCalendar(value);
        case 'holidayCalendar': return new HolidayCalendar(value);
        case 'identifications': return new Identification(value);
        case 'identification': return new Identification(value);
        case 'importExports': return new ImportExport(value);
        case 'importExport': return new ImportExport(value);
        case 'importSources': return new ImportSource(value);
        case 'importSource': return new ImportSource(value);
        case 'invoices': return new Invoice(value);
        case 'invoice': return new Invoice(value);
        case 'invoiceBatches': return new InvoiceBatch(value);
        case 'invoiceBatch': return new InvoiceBatch(value);
        case 'invoiceBatchItems': return new InvoiceBatchItem(value);
        case 'invoiceBatchItem': return new InvoiceBatchItem(value);
        case 'lawpays': return new Lawpay(value);
        case 'lawpay': return new Lawpay(value);
        case 'leads': return new Lead(value);
        case 'lead': return new Lead(value);
        case 'lookups': return new Lookup(value);
        case 'lookup': return new Lookup(value);
        case 'matterStages': return new MatterStage(value);
        case 'matterStage': return new MatterStage(value);
        case 'milestones': return new Milestone(value);
        case 'milestone': return new Milestone(value);
        case 'options': return new Option(value);
        case 'option': return new Option(value);
        case 'participants': return new Participant(value);
        case 'participant': return new Participant(value);
        case 'privileges': return new Privilege(value);
        case 'privilege': return new Privilege(value);
        case 'questions': return new Question(value);
        case 'question': return new Question(value);
        case 'redFlagTypes': return new RedFlagType(value);
        case 'redFlagType': return new RedFlagType(value);
        case 'redFlags': return new RedFlag(value);
        case 'redFlag': return new RedFlag(value);
        case 'resources': return new Resource(value);
        case 'resource': return new Resource(value);
        case 'referrals': return new Referral(value);
        case 'referral': return new Referral(value);
        case 'roles': return new Role(value);
        case 'role': return new Role(value);
        case 'tasks': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new Task(value);
        case 'task': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new Task(value);
        case 'taskSerieses': return new TaskSeries(value);
        case 'taskSeries': return new TaskSeries(value);
        case 'templateTasks': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new TemplateTask(value);
        case 'templateTask': return (value as any)?.deletionRecord === true && (value as any).firmId ? value as EntityType : new TemplateTask(value);
        case 'timeOffs': return new TimeOff(value);
        case 'timeOff': return new TimeOff(value);
        case 'transactions': return new Transaction(value);
        case 'transaction': return new Transaction(value);
        case 'users': return new User(value);
        case 'user': return new User(value);
        default: throw new Error('cast: Unknown entity: ' + entity);
    }
}
function schemaInfo(entity: string): EntitySchema {
    switch(entity) {
        case 'accountingConnections': return AccountingConnection.getSchema();
        case 'accountingConnection': return AccountingConnection.getSchema();
        case 'activityCategories': return ActivityCategory.getSchema();
        case 'activityCategory': return ActivityCategory.getSchema();
        case 'activityTypes': return ActivityType.getSchema();
        case 'activityType': return ActivityType.getSchema();
        case 'addresses': return Address.getSchema();
        case 'address': return Address.getSchema();
        case 'answers': return Answer.getSchema();
        case 'answer': return Answer.getSchema();
        case 'bankAccounts': return BankAccount.getSchema();
        case 'bankAccount': return BankAccount.getSchema();
        case 'blackouts': return Blackout.getSchema();
        case 'blackout': return Blackout.getSchema();
        case 'calendars': return Calendar.getSchema();
        case 'calendar': return Calendar.getSchema();
        case 'calendarShares': return CalendarShare.getSchema();
        case 'calendarShare': return CalendarShare.getSchema();
        case 'categories': return Category.getSchema();
        case 'category': return Category.getSchema();
        case 'campaigns': return Campaign.getSchema();
        case 'campaign': return Campaign.getSchema();
        case 'dockets': return Docket.getSchema();
        case 'docket': return Docket.getSchema();
        case 'matters': return Matter.getSchema();
        case 'matter': return Matter.getSchema();
        case 'comments': return Comment.getSchema();
        case 'comment': return Comment.getSchema();
        case 'caseTypes': return CaseType.getSchema();
        case 'caseType': return CaseType.getSchema();
        case 'caseTypeStages': return CaseTypeStage.getSchema();
        case 'caseTypeStage': return CaseTypeStage.getSchema();
        case 'deadlines': return Deadline.getSchema();
        case 'deadline': return Deadline.getSchema();
        case 'deadlineRules': return DeadlineRule.getSchema();
        case 'deadlineRule': return DeadlineRule.getSchema();
        case 'conflicts': return Conflict.getSchema();
        case 'conflict': return Conflict.getSchema();
        case 'contacts': return Contact.getSchema();
        case 'contact': return Contact.getSchema();
        case 'courts': return Court.getSchema();
        case 'court': return Court.getSchema();
        case 'courtDeadlineRules': return CourtDeadlineRule.getSchema();
        case 'courtDeadlineRule': return CourtDeadlineRule.getSchema();
        case 'discounts': return Discount.getSchema();
        case 'discount': return Discount.getSchema();
        case 'entityTimestamps': return EntityTimestamp.getSchema();
        case 'entityTimestamp': return EntityTimestamp.getSchema();
        case 'ethicalWalls': return EthicalWall.getSchema();
        case 'ethicalWall': return EthicalWall.getSchema();
        case 'documents': return Document.getSchema();
        case 'document': return Document.getSchema();
        case 'expenses': return Expense.getSchema();
        case 'expense': return Expense.getSchema();
        case 'events': return Event.getSchema();
        case 'event': return Event.getSchema();
        case 'firms': return Firm.getSchema();
        case 'firm': return Firm.getSchema();
        case 'flatFees': return FlatFee.getSchema();
        case 'flatFee': return FlatFee.getSchema();
        case 'flatFeeMilestones': return FlatFeeMilestone.getSchema();
        case 'flatFeeMilestone': return FlatFeeMilestone.getSchema();
        case 'groups': return Group.getSchema();
        case 'group': return Group.getSchema();
        case 'holidayCalendars': return HolidayCalendar.getSchema();
        case 'holidayCalendar': return HolidayCalendar.getSchema();
        case 'identifications': return Identification.getSchema();
        case 'identification': return Identification.getSchema();
        case 'importExports': return ImportExport.getSchema();
        case 'importExport': return ImportExport.getSchema();
        case 'importSources': return ImportSource.getSchema();
        case 'importSource': return ImportSource.getSchema();
        case 'invoices': return Invoice.getSchema();
        case 'invoice': return Invoice.getSchema();
        case 'invoiceBatches': return InvoiceBatch.getSchema();
        case 'invoiceBatch': return InvoiceBatch.getSchema();
        case 'invoiceBatchItems': return InvoiceBatchItem.getSchema();
        case 'invoiceBatchItem': return InvoiceBatchItem.getSchema();
        case 'lawpays': return Lawpay.getSchema();
        case 'lawpay': return Lawpay.getSchema();
        case 'leads': return Lead.getSchema();
        case 'lead': return Lead.getSchema();
        case 'lookups': return Lookup.getSchema();
        case 'lookup': return Lookup.getSchema();
        case 'matterStages': return MatterStage.getSchema();
        case 'matterStage': return MatterStage.getSchema();
        case 'milestones': return Milestone.getSchema();
        case 'milestone': return Milestone.getSchema();
        case 'options': return Option.getSchema();
        case 'option': return Option.getSchema();
        case 'participants': return Participant.getSchema();
        case 'participant': return Participant.getSchema();
        case 'privileges': return Privilege.getSchema();
        case 'privilege': return Privilege.getSchema();
        case 'questions': return Question.getSchema();
        case 'question': return Question.getSchema();
        case 'redFlagTypes': return RedFlagType.getSchema();
        case 'redFlagType': return RedFlagType.getSchema();
        case 'redFlags': return RedFlag.getSchema();
        case 'redFlag': return RedFlag.getSchema();
        case 'resources': return Resource.getSchema();
        case 'resource': return Resource.getSchema();
        case 'referrals': return Referral.getSchema();
        case 'referral': return Referral.getSchema();
        case 'roles': return Role.getSchema();
        case 'role': return Role.getSchema();
        case 'tasks': return Task.getSchema();
        case 'task': return Task.getSchema();
        case 'taskSerieses': return TaskSeries.getSchema();
        case 'taskSeries': return TaskSeries.getSchema();
        case 'templateTasks': return TemplateTask.getSchema();
        case 'templateTask': return TemplateTask.getSchema();
        case 'timeOffs': return TimeOff.getSchema();
        case 'timeOff': return TimeOff.getSchema();
        case 'transactions': return Transaction.getSchema();
        case 'transaction': return Transaction.getSchema();
        case 'users': return User.getSchema();
        case 'user': return User.getSchema();
        default: throw new Error('cast: Unknown entity: ' + entity);
    }
}
function getAll(): EntityTypeTypes[] {
    return [
AccountingConnection,
ActivityCategory,
ActivityType,
Address,
Answer,
BankAccount,
Blackout,
Calendar,
CalendarShare,
Category,
Campaign,
Docket,
Matter,
Comment,
CaseType,
CaseTypeStage,
Deadline,
DeadlineRule,
Conflict,
Contact,
Court,
CourtDeadlineRule,
Discount,
EntityTimestamp,
EthicalWall,
Document,
Expense,
Event,
Firm,
FlatFee,
FlatFeeMilestone,
Group,
HolidayCalendar,
Identification,
ImportExport,
ImportSource,
Invoice,
InvoiceBatch,
InvoiceBatchItem,
Lawpay,
Lead,
Lookup,
MatterStage,
Milestone,
Option,
Participant,
Privilege,
Question,
RedFlagType,
RedFlag,
Resource,
Referral,
Role,
Task,
TaskSeries,
TemplateTask,
TimeOff,
Transaction,
User];
}
export default {cast,schemaInfo,getAll,
AccountingConnection,
ActivityCategory,
ActivityType,
Address,
Answer,
BankAccount,
Blackout,
Calendar,
CalendarShare,
Category,
Campaign,
Docket,
Matter,
Comment,
CaseType,
CaseTypeStage,
Deadline,
DeadlineRule,
Conflict,
Contact,
Court,
CourtDeadlineRule,
Discount,
EntityTimestamp,
EthicalWall,
Document,
Expense,
Event,
Firm,
FlatFee,
FlatFeeMilestone,
Group,
HolidayCalendar,
Identification,
ImportExport,
ImportSource,
Invoice,
InvoiceBatch,
InvoiceBatchItem,
Lawpay,
Lead,
Lookup,
MatterStage,
Milestone,
Option,
Participant,
Privilege,
Question,
RedFlagType,
RedFlag,
Resource,
Referral,
Role,
Task,
TaskSeries,
TemplateTask,
TimeOff,
Transaction,
User
};